import Vue from "vue";
import VueProgressBar from "vue-progressbar";
import { useDrupalSettings } from "@/composables/useDrupalSettings";
import "@/composables/useNotification";
import BioMaterialDataWindow from "@/components/biologicals/BioMaterialDataWindow.vue";

const { config } = useDrupalSettings();

const BioSpaceListing = () =>
  import("@/components/biologicals/BioSpaceListing.vue");

const InstitutionalBiologicalsListing = () =>
  import("../../components/biologicals/InstitutionalBiologicalsListing.vue");

const SpecifyUsageParent = () =>
  import("@/components/biologicals/SpaceMaterialsUsage/SpecifyUsageParent.vue");
const SpaceProjectActivitiesListing = () =>
  import(
    "../../components/biologicals/ProjectActivities/SpaceProjectActivitiesListing.vue"
  );
const BioRegToc = () => import("@/components/biologicals/BioRegToc.vue");

const BioProjectMaterialsModal = () =>
  import("@/components/biologicals/BioProjectMaterialsModal.vue");

const options = {
  color: "#41b883",
  failedColor: "#874b4b",
  thickness: "8px",
  transition: {
    speed: "0.02s",
    opacity: "0.8s",
    termination: 9000,
  },
  autoRevert: true,
  autoFinish: false,
  location: "top",
  inverse: false,
};
Vue.use(VueProgressBar, options);

const routes = [
  {
    path: "/user/:userUid([0-9]+)/bio-materials",
    component: BioSpaceListing,
    name: "user_bio_material_listing",
    props: true,
  },
  {
    path: "/raft/biologicals/bio_reports/:materialType([a-z0-9_]+)/:inLibrary?",
    component: InstitutionalBiologicalsListing,
    props: (route) => ({
      materialType: route.params.materialType,
      inLibrary: route.params.inLibrary === "library",
    }),
  },
  {
    path: "/node/:groupNid([0-9]+)/biologicals/projects/specify-usage",
    component: SpecifyUsageParent,
    name: "project_space_material_usage",
    props: true,
  },
];

if (config.nodeType === "space") {
  routes.push({
    path: "/node/:spaceNid([0-9]+)",
    component: SpaceProjectActivitiesListing,
    name: "project_activities_on_space_node",
    props: true,
  });
}

const globalComponents = {
  "space-materials-usage": SpecifyUsageParent,
  "bio-reg-toc": BioRegToc,
  "bio-project-materials-modal": BioProjectMaterialsModal,
  "bio-material-data-window": BioMaterialDataWindow,
};

export {
  routes as biologicalsRoutes,
  globalComponents as biologicalsGlobalComponents,
};
